import React, { useState, useEffect, useCallback, useMemo } from "react";
import APIService from "../../Services/API/APIService";
import {
    Table,
    Dimmer,
    Loader,
    Dropdown,
    Modal,
    Label,
    Pagination,
} from "semantic-ui-react";
import dayjs from "dayjs";
import numeral from "numeral";
import { toast } from "react-toastify";
import PaystackDetails from "./PaystackDetails";
import ProductTypes from "../../Data/ProductTypes";

const BackOffice = (props) => {
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(false);
  //  const [searchPhrase, setSearchPhrase] = useState(null);
    const [response, setResponse] = useState(null)
    const [resturantOrder, setResturantOrder] = useState([])

    const [payout, setPayout] = useState([])
    const [paystackModalState, togglePaystackModal] = useState(false);

    const [offset, setOffset] = useState(0);
    const [limit] = useState(50);
    const [rowCount, setRowCount] = useState(0);


    let query = useMemo(() => {
        return {
            offset: offset,
            limit: limit,
        }
    }, [limit, offset])
    const fetchData = useCallback(async (isSubscribed) => {
        try {
            setLoading(true);
            let result = await APIService.getData("/guest-house/getBookingsTreasurer", {
                ...query
            }
            );
            let payout = await APIService.getData("/checkout/getAllPayout", {
                ...query
            }
            );
            let resturant = await APIService.getData("/guest-house/getResturantTreasurer", {
                ...query
            }
            );

            if(isSubscribed){

                setResturantOrder(resturant.orders)
                setPayout(payout)
                setBookings(result.bookings);
                setRowCount(result.count)
            }

            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }, [query])


    useEffect(() => {
        let isSubscribed = true;

        fetchData(isSubscribed);
        return () => (isSubscribed = false);
    }, [fetchData]);


    // const _searchChanged = (e) => {
    //   setSearchPhrase(e.target.value);
    
    //  };

    const checkPayment = async (item, mode) => {
        try {


            if (item.GuestHousePayment?.[`${mode}paymentMode`] === "DIRECT_TRANSFER") {
                setLoading(true);
                let response = await APIService.postData(
                    `/checkout/checkPayment`,
                    { GuestHousePaymentId: item.GuestHousePaymentId, mode: mode }
                );
                var win = window.open(response?.location, "_blank");
                win.focus();

                setLoading(false);
            } else if (item.GuestHousePayment?.[`${mode}paymentMode`] === "PAYSTACK") {
                try {
                    setLoading(true);

                    let response = await APIService.getData(
                        `/checkout/verifyPaystackPayment/`,
                        { reference: mode === 'checkin' ? item.GuestHousePayment?.payReference : item.GuestHousePayment?.checkoutpayReference }

                    );

                    setResponse(response)
                    togglePaystackModal(true)
                    setLoading(false);

                } catch (error) {
                    toast.error("Error completing action");
                    setLoading(false);
                }

            } else if (item?.paymentMode === "DIRECT_TRANSFER") {
                setLoading(true);

                let response = await APIService.postData(
                    `/checkout/checkPayment`,
                    { GuestHousePaymentId: item.GuestHousePaymentId, mode: mode }
                );
                win = window.open(response?.location, "_blank");
                win.focus();

                setLoading(false);
            }
        } catch (error) {
            console.log("error", error);
            setLoading(false);
        }
    };


    // const _search = async () => {
    //     setLoading(true);
    //     try {
    //         let result = [];
    //         if (searchPhrase) {
    //             result = await APIService.getData(`/order/search/${searchPhrase}`);
    //         } else {
    //             result = await APIService.getData("/order");
    //         }
    //         setLoading(false);
    //         setBookings(result);
    //     } catch (error) {
    //         console.log("error", error);
    //         setLoading(false);
    //     }
    // };

    const approvePayment = async (item, type) => {
        try {
            setLoading(true);
            let url
            type === true ? url = `/checkout/approvePayment` : url = `/guest-house/approvePayment`
            await APIService.postData(`${url}`, item);
            toast.success("Confirmed successful");
            fetchData(true);
        } catch (error) {
            console.log("error", error);
            setLoading(false);
        }
    };


    const cancelPayment = async (item, type) => {
        try {
            if (window.confirm("Are you sure you want to cancel this Booking?")) {
                setLoading(true);
                let url
                type === true ? url = `/checkout/approvePayment` : url = `/guest-house/cancelPayment`
                await APIService.postData(
                    `${url}`,
                    item
                );

                toast.success("Cancelled Successful");
                fetchData(true);
            }
        } catch (error) {
            console.log("error", error);
            setLoading(false);
        }
    };





    let counter = 0
    const mode = ['PAYSTACK', 'DIRECT_TRANSFER']
    const bookingItems = bookings?.map((item) => (

        <>
            {mode.includes(item.GuestHousePayment?.checkinpaymentMode) &&
                !item?.checkinPayment
                && (
                    <Table.Row key={item.id}>

                        <Table.Cell> {counter = counter + 1}</Table.Cell>
                        <Table.Cell>{item.bookingId}</Table.Cell>
                        <Table.Cell>{dayjs(item.createdAt).format("DD-MMM-YYYY")}</Table.Cell>

                        <Table.Cell> {item.GuestHouseUser?.email !== ProductTypes.GUESTHOUSE_EMAIL ? item.GuestHouseUser?.firstname + "  " + item.GuestHouseUser?.lastname :
                            item.GuestHouseSecretUser?.firstname + " " + item.GuestHouseSecretUser?.lastname}</Table.Cell>

                        <Table.Cell>
                            ₦{numeral(item?.GuestHousePayment?.checkinTotal).format("0,0")}
                        </Table.Cell>
                        {!item?.checkinPayment && (
                            <Table.Cell>
                                <Label
                                    onClick={() => checkPayment(item, 'checkin')}
                                    color={
                                        item.GuestHousePayment?.checkinpaymentMode === "DIRECT_TRANSFER"
                                            ? "violet"
                                            : item.GuestHousePayment?.checkinpaymentMode === "PAYSTACK"
                                                ? "olive"

                                                : "brown"
                                    }
                                >
                                    {item.GuestHousePayment?.checkinpaymentMode}


                                </Label>

                            </Table.Cell>
                        )
                        }

                        <Table.Cell>
                            <Dropdown icon="ellipsis vertical" fluid floating pointing="bottom right">
                                <Dropdown.Menu>
                                    {(item.status) && (
                                        <>
                                            <Dropdown.Item
                                                icon="check"
                                                text="Confirm Payment"
                                                onClick={() => approvePayment(item, true)}
                                            />
                                            <Dropdown.Item
                                                icon="cut"
                                                text="Drop Payment!"
                                                onClick={() => cancelPayment(item, true)}
                                            />
                                        </>
                                    )}


                                </Dropdown.Menu>
                            </Dropdown>
                        </Table.Cell>
                    </Table.Row>
                )}




            {mode.includes(item.GuestHousePayment?.checkoutpaymentMode) &&
                !item?.checkoutPayment

                && (
                    <Table.Row key={item.id}>

                        <Table.Cell> {counter = counter + 1}</Table.Cell>
                        <Table.Cell>{item.bookingId}</Table.Cell>
                        <Table.Cell>{dayjs(item.createdAt).format("DD-MMM-YYYY")}</Table.Cell>

                        <Table.Cell> {item.GuestHouseUser?.email !== ProductTypes.GUESTHOUSE_EMAIL ? item.GuestHouseUser?.firstname + "  " + item.GuestHouseUser?.lastname :
                            item.GuestHouseSecretUser?.firstname + " " + item.GuestHouseSecretUser?.lastname}</Table.Cell>

                        <Table.Cell>
                            ₦{numeral(item?.GuestHousePayment?.checkoutTotal).format("0,0")}
                        </Table.Cell>

                        {!item?.checkoutPayment &&
                            (<Table.Cell>
                                <Label
                                    onClick={() => checkPayment(item, 'checkout')}
                                    color={
                                        item.GuestHousePayment?.checkoutpaymentMode === "DIRECT_TRANSFER"
                                            ? "violet" : item.GuestHousePayment?.checkoutpaymentMode === "PAYSTACK"
                                                ? "olive"
                                                : "brown"
                                    }
                                >
                                    {
                                        item.GuestHousePayment?.checkoutpaymentMode}


                                </Label>

                            </Table.Cell>)}



                        <Table.Cell>
                            <Dropdown icon="ellipsis vertical" fluid floating pointing="bottom right">
                                <Dropdown.Menu>
                                    {(item.status) && (
                                        <>
                                            <Dropdown.Item
                                                icon="check"
                                                text="Confirm Payment"
                                                onClick={() => approvePayment(item, true)}
                                            />
                                            <Dropdown.Item
                                                icon="cut"
                                                text="Drop Payment!"
                                                onClick={() => cancelPayment(item, true)}
                                            />
                                        </>
                                    )}


                                </Dropdown.Menu>
                            </Dropdown>
                        </Table.Cell>
                    </Table.Row>
                )}

        </>
    ));



    const resturantItems = resturantOrder?.map((item) => (

        <>
            {true &&
                (
                    <Table.Row key={item.id}>

                        <Table.Cell> {counter = counter + 1}</Table.Cell>
                        <Table.Cell>{item.orderId}</Table.Cell>
                        <Table.Cell>{dayjs(item.createdAt).format("DD-MMM-YYYY")}</Table.Cell>

                        <Table.Cell> {item?.firstname + "  " + item?.lastname}</Table.Cell>

                        <Table.Cell>
                            ₦{numeral(item?.price).format("0,0")}
                        </Table.Cell>
                        <Table.Cell>
                            <Label
                                onClick={() => checkPayment(item, 'checkin')}
                                color={
                                    'violet'
                                }
                            >
                                {item.paymentMode}


                            </Label>

                        </Table.Cell>



                        <Table.Cell>
                            <Dropdown icon="ellipsis vertical" fluid floating pointing="bottom right">
                                <Dropdown.Menu>

                                    <>
                                        <Dropdown.Item
                                            icon="check"
                                            text="Confirm Payment"
                                            onClick={() => approvePayment(item, false)}
                                        />
                                        <Dropdown.Item
                                            icon="cut"
                                            text="Drop Payment!"
                                            onClick={() => cancelPayment(item, false)}
                                        />
                                    </>



                                </Dropdown.Menu>
                            </Dropdown>
                        </Table.Cell>
                    </Table.Row>
                )}








        </>
    ));
    return (

        <div>
            {loading && (
                <Dimmer active inverted>
                    <Loader />
                </Dimmer>
            )}


            {/* <Menu secondary stackable>

                <Menu.Menu position="right">
                    <Menu.Item>
                        <Form>
                            <Form.Input
                                placeholder="Name, Email or Phone"
                                icon="search"
                                onChange={_searchChanged}
                                action={{
                                    onClick: _search,
                                    color: '#26f09e'
                                }}
                                disabled
                            />
                        </Form>
                    </Menu.Item>
                </Menu.Menu>
            </Menu> */}

            {bookings && (
                <Table basic striped celled compact size="small">
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>S/N</Table.HeaderCell>
                            <Table.HeaderCell>Booking ID</Table.HeaderCell>
                            <Table.HeaderCell>Booked Date</Table.HeaderCell>
                            <Table.HeaderCell>Customer Name</Table.HeaderCell>
                            <Table.HeaderCell>Paid</Table.HeaderCell>
                            <Table.HeaderCell>Payment</Table.HeaderCell>

                            <Table.HeaderCell></Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>{bookingItems}</Table.Body>
                    <Table.Body>{resturantItems}</Table.Body>
                </Table>
            )}


            <Pagination
                defaultActivePage={1}
                totalPages={Math.ceil(rowCount / limit)}
                onPageChange={(e, { activePage }) =>
                    setOffset(1 + (activePage - 1) * limit)
                }
            />





            <Modal
                size="small"
                open={paystackModalState}
                onClose={() => togglePaystackModal(false)}
                closeIcon
            >
                <Modal.Header>Paystack Details</Modal.Header>
                <Modal.Content>

                    <PaystackDetails receipt={response} payout={payout} />
                </Modal.Content>
            </Modal>






        </div>


    );
};

export default BackOffice;
